/**
 * TimeIcon — sanitized from `assets/newSvg/time.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function TimeIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M12,2 C17.5228,2 22,6.47715 22,12 C22,17.5228 17.5228,22 12,22 C6.47715,22 2,17.5228 2,12 C2,6.47715 6.47715,2 12,2 Z M12,6 C11.4477,6 11,6.44772 11,7 L11,12 C11,12.2652 11.1054,12.5196 11.2929,12.7071 L14.2929,15.7071 C14.6834,16.0976 15.3166,16.0976 15.7071,15.7071 C16.0976,15.3166 16.0976,14.6834 15.7071,14.2929 L13,11.5858 L13,7 C13,6.44772 12.5523,6 12,6 Z"
        fill={color}
      />
    </Svg>
  );
}

export default TimeIcon;
